import { Directive } from '@angular/core';

@Directive({
  selector: 'input[appInput], textarea[appInput]',
  host: {
    class:
      'flex h-9 w-full rounded-md border border-border bg-white px-3 py-1 text-sm ' +
      'placeholder:text-muted focus-visible:outline-none focus-visible:ring-2 ' +
      'focus-visible:ring-primary disabled:opacity-50',
  },
})
export class InputDirective {}
